// extracted by mini-css-extract-plugin
export var founder = "founder-module--founder--3fcVN";
export var title = "founder-module--title--38Wva";
export var row = "founder-module--row--14eU-";
export var copy = "founder-module--copy--nZrbm";
export var portraitContainer = "founder-module--portraitContainer--3wIak";
export var portraitInner = "founder-module--portraitInner--2AoT_";
export var portrait = "founder-module--portrait--1w_ZC";
export var giantTwelve = "founder-module--giantTwelve--18p6H";
export var inView = "founder-module--inView--1K1ML";